<template>
  <div class="completed_challenges">
    <div class="completed_challenges_title">
      Completed Challenges <span style="color: #8F8F8F;">({{ countCompletedChallenges }})</span>
    </div>
    <div class="completed_challenges_content landing_slider">
      <template v-if="isMobile()">
        <div
          ref="hub_completed_quests_slick"
          class="variable-width"
          data-slick="{&quot;infinite&quot;: false, &quot;speed&quot;: 300, &quot;slidesToShow&quot;: 3, &quot;centerMode&quot;: false, &quot;variableWidth&quot;: true, &quot;initialSlide&quot;: 0, &quot;draggable&quot;: true, &quot;responsive&quot;: [ {&quot;breakpoint&quot;: 1000, &quot;settings&quot;: {&quot;slidesToShow&quot;: 2, &quot;slidesToScroll&quot;: 1}}, {&quot;breakpoint&quot;: 576, &quot;settings&quot;: {&quot;slidesToShow&quot;: 1, &quot;slidesToScroll&quot;: 1}}]}"
          style="min-width: 100%; width: 0"
        >
          <quest-card-hub
            v-for="(quest, idx) in completedQuests"
            :key="idx"
            :quest="quest"
          />
        </div>
      </template>
      <template v-else>
        <div
          v-for="(row, index) in listRowCompletedQuests"
          :key="index"
          class="completed_challenges_row"
        >
          <quest-card-hub
            v-for="(quest, idx) in row"
            :key="idx"
            :quest="quest"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import QuestCardHub from './QuestCardHub';
import { component } from '../../../mixins/component';
import 'slick-carousel/slick/slick.min';
import Vue from 'vue';
import jQuery from 'jquery';
import chunk from 'lodash/chunk';

export default {
  components: { QuestCardHub },
  mixins: [component],
  props: {
    completedQuests: {
      type: [Object, Array],
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      listRowCompletedQuests: [],
    };
  },
  computed: {
    countCompletedChallenges() {
      return this.completedQuests.length;
    },
  },
  watch: {
    completedQuests: function(newVal, oldVal) {
      this.destroySlick();
      Vue.nextTick(() => {
        this.initSlick();
      });
      this.listRowCompletedQuests = chunk(newVal, 2);
    },
  },
  created() {
    this.listRowCompletedQuests = chunk(this.completedQuests, 2);
    Vue.nextTick(() => {
      this.initSlick();
    });
  },
  methods: {
    initSlick() {
      jQuery(this.$refs.hub_completed_quests_slick).slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        centerMode: false,
        variableWidth: true,
        initialSlide: 0,
        draggable: true,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
      jQuery(this.$refs.hub_completed_quests_slick).find('.slick-prev').first().css('background-color', this.hubDropsTheme);
      jQuery(this.$refs.hub_completed_quests_slick).find('.slick-next').first().css('background-color', this.hubDropsTheme);
      var slideCount = 0;
      jQuery(this.$refs.hub_completed_quests_slick)
        .find('.slick-prev')
        .first()
        .addClass('btn_slick_disable');
      jQuery(this.$refs.hub_completed_quests_slick).on('beforeChange', function(
        event,
        slick,
        current_slide,
        nextSlide
      ) {
        if (nextSlide === 0) {
          jQuery(this).find('.slick-prev').first().addClass('btn_slick_disable');
        } else {
          jQuery(this).find('.slick-prev').first().removeClass('btn_slick_disable');
        }
      });
      jQuery(this.$refs.hub_completed_quests_slick).on('afterChange', function(
        event,
        slick,
        current_slide
      ) {
        var slide_show = slick.slickGetOption('slidesToShow');
        slideCount = jQuery(this).find('.drops_works_card').length;
        if (current_slide > slideCount - slide_show - 1) {
          jQuery(this).find('.slick-next').first().addClass('btn_slick_disable');
        } else {
          jQuery(this).find('.slick-next').first().removeClass('btn_slick_disable');
        }
      });
    },
    destroySlick() {
      jQuery(this.$refs.hub_completed_quests_slick).slick('unslick');
    },
  },
};
</script>
